import React from 'react';
import { FiChevronDown } from 'react-icons/fi';
import './Hero.css';

function Hero() {
  const scrollDown = () => {
    const whoWeAre = document.getElementById('who-we-are');
    if (whoWeAre) {
      const bottom = whoWeAre.offsetTop + whoWeAre.offsetHeight;
      window.scrollTo({ top: bottom, behavior: 'smooth' });
    }
  };

  return (
    <section className="hero">
      <div className="hero-bg">
        <div className="hero-content container">
          <div className="hero-text">
            <h1>Build an integrated digital workplace for the future</h1>
            <p>Employee Productivity & Experience</p>
            <button className="scroll-down" onClick={scrollDown} aria-label="Scroll down">
              <FiChevronDown size={30} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
